import { configureStore } from '@reduxjs/toolkit';
import reservationReducer from '../Redux/Slices/agentAuthSlice';
import voucherReducer from "./Slices/reservationVoucherSlice";
import businessSourceReportReducer from "./Slices/BusinessSourceReportSlice";
import marketSegmentReportReducer from "./Slices/MarketSegmentReportSlice";
import termsReducer from "./Slices/termsSlice";
import connectivityReducer from "./Slices/connectivitySlice";
import voucherOffersReducer from "./Slices/voucherOffersSlice";
import agentReportReducer from "./Slices/reservationAgentReportSlice";
import companyReportReducer from "./Slices/reservationCompanyReportSlice";
import pmsReducer from "./Slices/reserPmsSlice";
import inventoryReducer from "./Slices/reseinventorySlice";
import PropPmsReducer from "./Slices/propPmsSlice";
import propinventoryReducer from "./Slices/reseinventorySlice";
import bookingEngineReducer from "./Slices/BookingEngineSlice";
import propertyReducer from "./Slices/BON-Frontend/propertySlice";
import reservationMasterReducer from "./Slices/reservationMasterSlice";
import editBookingReducer from './Slices/ReserEditBookingSlice';
import roomAvailabilityReducer from "./Slices/ReservationRoomAval.slice";
import preBookingReducer from "./Slices/BON-Frontend/roomAvailabilitySlice";
import confirmBookingReducer from './Slices/BON-Frontend/confirmBookingSlice';
import propertyListReducer from "./Slices/BON-Frontend/propertyListSlice";
import frontTermsReducer from "./Slices/BON-Frontend/frontTermsSlice";
import agentRoomRestrictionReducer from "./Slices/agentRoomRestriction";
export const store = configureStore({
  reducer: {
    reservation: reservationReducer,
    voucher: voucherReducer,
    businessSourceReport: businessSourceReportReducer,
    marketSegmentReport: marketSegmentReportReducer,
    terms: termsReducer,
    connectivity: connectivityReducer,
    voucherOffers: voucherOffersReducer,
    agentProduReport: agentReportReducer,
    companyProduReport: companyReportReducer,
    pms: pmsReducer,
    inventory: inventoryReducer,
    PropPMS: PropPmsReducer,
    propinventory: propinventoryReducer,
    bookingEngine: bookingEngineReducer,
    property: propertyReducer,
    reservationMasters: reservationMasterReducer,
    ResereditBooking: editBookingReducer,
    ReserroomAvailability: roomAvailabilityReducer,
    // forntend 
    preBooking: preBookingReducer,
    confirmBooking: confirmBookingReducer,  
    propertyList: propertyListReducer,
    frontTerms: frontTermsReducer,
    agentRoomRestriction: agentRoomRestrictionReducer,  
  },
});
